import React, { Component } from "react";
import Header from "../Layout/Header/Header";
import Footer from "../Layout/Footer/Footer";
import imgBg from "../../Assets/img/Group 2521.svg";
import imgMain from "../../Assets/img/Group 2286.svg";
import { authenticate, get_current_level } from "../Utils/Utils";

class NotFound extends Component {

  playEdition = () => {
    if (authenticate()) {
      get_current_level();
    } else {
      window.location = '/';
    }
  }


  render() {
    return (
      <div className="NotFound innerBody">
        <Header />
        <div className="container">
          <div className="row">
            <div className="col text-center">
              <h3 className="title ml-auto mr-auto text-center mt-4">
                404: Dear Puzzler, You are Wandering in Unauthorized Territory!
              </h3>
              <p className="mt-4 col-8 text-center offset-2 text-white">
                All that is gold does not glitter,
                Not all those who wander are lost;
                The old that is strong does not wither,
                Deep roots are not reached by the frost.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col text-center mb-4">
              <img src={imgBg} className="bg_img" alt="" />
              <img src={imgMain} alt="" className="img-main" />
              <div className="pt-4 pb-2">
                <button id="register_btn" className="btn btn-yellow g-recaptcha" onClick={this.playEdition}>TAKE ME HOME</button>
              </div>
              <img src={imgBg}  className="bg_img" alt="" />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

}  
export default NotFound;
